<template>
  <div class="flex flex-col items-start w-full gap-4">
    <div class="flex items-center gap-2.5">
      <img :src="img" alt="" class="h-8 w-8" />
      <h1 class="text-md text-gray-3">{{ title }}</h1>
    </div>
    <h1 class="text-white font-bold text-3xl">{{ amount }}</h1>
  </div>
</template>

<script>
export default {
  name: "ChartHeader",
  components: {},
  props: {
    img: {
      type: String,
      default: "/icons/dollar.png",
    },
    title: {
      type: String,
      default: "Fees",
    },
    amount: {
      type: String,
      default: "$1,042",
    },
  },
};
</script>
